
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/callback",
      function () {
        return require("private-next-pages/callback.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/callback"])
      });
    }
  